<template>
  <div v-if="!orderExpired" class="payment">
    <div class="payment__header">
      <div class="payment__header--left">
        <h2 class="large-title" >Order Information</h2>
        <p v-if="!orderNotFound" class="small-font">Set detail info for this order</p>
      </div>
    </div>
    <div v-if="isLoadInfo" class="payment__loading">
      <adx-loading slot="loading" />
    </div>
    <template v-if="!isLoadInfo && !orderNotFound">
      <!-- <div class="payment__breadcrumb">
        <adx-breadcrumb :items="breadcrumb" />
      </div> -->
      <div class="payment__content">
        <div class="payment__content--left">
          <div class="payment__content__info">
            <div class="header">
              <span class="subhead strong">Client Informations</span>
            </div>
            <div class="payment__content__info__fields">
              <adx-input :label="`Company Name (Optional)`" :value.sync="company" />
              <adx-input :ref="dataRef.fullName" :inputId="dataRef.fullName" :label="`Contact Person *`" :error.sync="fullNameError" :validation="['NotEmpty', 'MinLength:2', 'MaxLength:100']" :value.sync="fullName" />
            </div>
            <div class="payment__content__info__fields">
              <adx-input :ref="dataRef.email" :inputId="dataRef.email" :label="`Email Address *`" :error.sync="emailAddressError" :validation="['NotEmpty', 'Email']"  :value.sync="emailAddress" />
              <adx-input :ref="dataRef.mobile" :inputId="dataRef.mobile" :label="`Phone Number *`" :error.sync="mobileError" :validation="['NotEmpty', 'Phone', 'Numeric', 'MinLength:7', 'MaxLength:15']" :value.sync="mobile" />
            </div>
          </div>
        </div>
        <div class="payment__content--right">
          <div class="payment__content__order-summary">
            <div class="payment__content__order-summary__header">
              <span class="subhead strong">Order Summary</span>
            </div>
            <div class="payment__content__order-summary__info">
              <div class="payment__content__order-summary__info__content" v-for="(campaign, index) in campaigns" :key="index">
                <div class="payment__content__order-summary__info__content--left subhead">
                  {{ campaign.title }}
                </div>
                <div class="payment__content__order-summary__info__content--right">
                  <span class="subhead strong">{{priceBeforeTax(campaign.net_price) | formatMoney}}</span>
                </div>
                <div class="payment__clear-both"></div>
              </div>
              <div class="payment__content__order-summary__info__content">
                <div class="payment__content__order-summary__info__content--left">
                  <span class="subhead">PPN 10%</span>
                </div>
                <div class="payment__content__order-summary__info__content--right">
                  <span class="subhead strong">{{ vat | formatMoney}}</span>
                </div>
                <div class="payment__clear-both"></div>
              </div>
              <div class="breaker"></div>
              <div class="payment__content__order-summary__info__content">
                <div class="payment__content__order-summary__info__content--left">
                  <span class="subhead strong">Sub Total</span>
                </div>
                <div class="payment__content__order-summary__info__content--right">
                  <span class="subhead strong">{{ totalOrder | formatMoney}}</span>
                </div>
                <div class="payment__clear-both"></div>
              </div>
            </div>
          </div>
          <div class="payment__content__price">
            <div class="payment__content__price--left">
              <span class="strong subhead">Total Price</span>
            </div>
            <div class="payment__content__price--right">
              <span class="payment__content__price__total regular-font">{{totalPrice | formatMoney}}</span>
            </div>
            <div class="payment__clear-both"></div>
          </div>
          <div class="payment__content__buttons">
            <button class="btn-block primary paynow not-rounded" @click.stop="checkBeforePay()" :disabled="loadingMidTrans">
              Send Order
            </button>
            <adx-loading-white v-if="loadingMidTrans" class="loading-circle" />
          </div>
          <div class="payment__content__buttons-fixed">
            <button class="btn-block primary paynow not-rounded" @click.stop="checkBeforePay()" :disabled="loadingMidTrans">
              Send Order
            </button>
            <adx-loading-white v-if="loadingMidTrans" class="loading-circle" />
          </div>
        </div>
      </div>
    </template>
    <div v-if="!isLoadInfo && orderNotFound" class="payment__not_found">
      <img src="/img/notfound/notfound@2x.png" alt="">
      <p class="not-found large-font strong">Order not found.</p>
    </div>
    <adx-modal v-if="isModalOpen" @modal-close="toggle">
      <div slot="content">
        <div class="payment__modal">
          <div class="top">Do you want to save your personal data changes?</div>
          <div class="bottom">
            <button class="btn-small secondary" @click.stop="sendOrder()">No</button>
            <button class="btn-small primary" @click.stop="saveProfile()">Yes</button>
          </div>
        </div>
      </div>
    </adx-modal>
  </div>
  <div v-else class="expired">
    <div class="expired__container">
      <img class="expired__container__image" src="/img/order_expired/expired@2x.png" alt="">
      <h2 class="expired__container__subheader smedium-title">Sorry, your payment has been expired :(</h2>
      <p class="expired__container__detail">We are really sorry, but your current payment has been expired,
        to retry current payment procces please clicks big button bellow!</p>
      <span class="expired__container__btn_expired">
        <button v-if="!orderFixed" type="button" class="primary btn-regular" @click.stop="duplicateOrder(orderId)">Retry Payment Procces</button>
      </span>
    </div>
  </div>
</template>

<script>
import Input from '@/components/Form/Input'
import Loading from '@/components/Loading/Primary'
import LoadingSpinner from '@/components/Loading/Secondary'
import LoadingSpinnerWhite from '@/components/Loading/Secondary-white'
import Modal from '@/components/Modal'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { midtransConfig } from '@/lib/config'

export default {
  name: "adx-order-detail",
  components: {
    'adx-input': Input,
    'adx-modal': Modal,
    'adx-loading': Loading,
    'adx-loading-secondary': LoadingSpinner,
    'adx-loading-white': LoadingSpinnerWhite
  },
  data(){
    return {
      dataRef: {
        fullName: 'fullName',
        email: 'email',
        mobile: 'mobile',
      },
      mapDataAPI: {
        // api key: front end key (from dataRef key)
        email: 'email',
        full_name: 'fullName',
        mobile: 'mobile',
      },
      campaigns: [],
      user: {},
      orderId: 0,
      orderNotFound: false,
      orderExpired: false,
      orderFixed: true,
      isLoadInfo: false,
      isLoadTotalOrder: false,
      loadingMidTrans: false,
      fullName: '',
      company: '',
      emailAddress: '',
      mobile: '',
      fullNameError: '',
      companyError: '',
      emailAddressError: '',
      mobileError: '',
      vat: 0,
      subTotal: 0,
      totalOrder: 0,
      isModalOpen: false,
      fullNameTemp: '',
      companyTemp: '',
      emailAddressTemp: '',
      mobileTemp: '',
      isSaved: false,
      isPromoCodeValid: false,
    }
  },
  created() {
    let newScript = document.createElement('script')
    newScript.setAttribute('src', midtransConfig.lib)
    newScript.setAttribute('data-client-key', midtransConfig.key)
    document.head.appendChild(newScript)
  },
  beforeMount() {
    if (this.$route.params && this.$route.params.id) {
      this.orderId = this.$route.params.id
    }
  },
  mounted() {
    this.getOrderDetail()
  },
  methods: {
    priceBeforeTax(price) {
      return Math.round((100/110) * price)
    },
    getOrderDetail() {
      (async () => {
        this.isLoadInfo = true
        let response = await api.get(apiV2.orderDetail(this.orderId), {needToken: true})
        if (response.status == 200) {
          this.campaigns = response.data.campaigns
          let user = response.data.user
          if (user) {
            this.fullName = user.full_name
            this.company = user.company
            this.emailAddress = user.email
            this.mobile = user.phone
            // Temporary for personal data changes checking
            this.fullNameTemp = user.full_name
            this.companyTemp = user.company
            this.emailAddressTemp = user.email
            this.mobileTemp = user.phone
          }
          this.isLoadInfo = false
        } else {
          if (response.status == 404 || response.status == 403) {
            this.orderNotFound = true
          } else if (response.status == 400) {
            if (response.data) {
              if (response.data.status == 'expired') {
                this.orderExpired = true
                this.orderFixed = response.data.is_fixed
              }
            }
          }
          this.isLoadInfo = false
        }
      })();
    },
    sendOrder(){
      this.isModalOpen = false
      this.isSaved = false;
      (async () => {
        this.loadingMidTrans = true
        let data = {
          email: this.emailAddress,
          name: this.fullName,
          phone: this.mobile,
          company: this.company,
	        order_id: this.orderId
        }
        let response = await api.post(apiV2.orderSend, data, {needToken: true})
        if (response.status == 201) {
          this.$router.push({name:'orderdetailsuccess'})
        } else {
          this.loadingMidTrans = false
          let message = "Send Order Failed"
          if (response.status == 400) {
            message = response.data.message
          } else if (response.status == 404) {
            message = "Order ID doesn't exists"
          }
          this.$notify({
            group: 'saved',
            title: `failed`,
            text: message,
            type: 'warn'
          })
        }
      })();
    },
    pay() {
      this.isModalOpen = false
      this.isSaved = false;
      (async () => {
        this.loadingMidTrans = true
        let data = {
          email: this.emailAddress,
          full_name: this.fullName,
          mobile: this.mobile,
          company: this.company,
        }
        if (this.totalPrice !== 0) {
          let response = await api.post(apiV2.midtransToken(this.orderId), data, {needToken: true})
          if (response.status == 201) {
            snap.pay(response.data.token)
            this.loadingMidTrans = false
          } else if (response.status == 400) {
            for (let key in response.data) {
              this.raiseError(this.mapDataAPI[key])
            }
          }
        } else {
          let response = await api.post(apiV2.zeroPayment(this.orderId), data, {needToken: true})
          if (response.status == 201) {
            this.$router.push({ name: 'transaction' })
          } else if (response.status == 400) {
            for (let key in response.data) {
              this.raiseError(this.mapDataAPI[key])
            }
          }
        }
      })();
    },
    validate_user_billing() {
      let data = { isValid: true, id: null }
      let dataRef = this.dataRef

      for (let key in this.dataRef) {
        let value = document.getElementById(dataRef[key]).value
        if (!value || this.inputInvalid(dataRef[key])) {
          data.isValid = false
          data.id = this.dataRef[key]
          break
        }
      }

      return data
    },
    raiseError(id) {
      let element = this.$refs[id].$el.firstElementChild
      element.focus()
      element.blur()
    },
    inputInvalid(value) {
      let error = ''
      let dataRef = this.dataRef
      switch(value) {
        case dataRef.fullName:
          error = this.fullNameError
          break
        case dataRef.email:
          error = this.emailAddressError
          break
        case dataRef.mobile:
          error = this.mobileError
          break
      }

      return error
    },
    toggle() {
      this.isModalOpen = !this.isModalOpen
    },
    checkBeforePay() {
      // Form validation
      let validation = this.validate_user_billing()
      if (validation.isValid) {
        // If valid check profile data changes
        if (this.fullNameTemp != this.fullName || 
          this.companyTemp != this.company ||
          this.emailAddressTemp != this.emailAddress ||
          this.mobileTemp != this.mobile) {
          this.toggle()
        } else {
          this.sendOrder()
        }
      } else {
        this.raiseError(validation.id)
      }
    },
    saveProfile() {
      (async () => {
        this.loadingMidTrans = true
        this.toggle()
        let data = {
          'full_name': this.fullName,
          'email': this.emailAddress,
          'mobile': this.mobile,
          'address': this.address
        }
        const response = await api.put(apiV2.userProfile, data, { needToken: true })
        if (response.status === 200) {
          this.$notify({
            group: 'saved',
            title: `success`,
            text: `edit profile success`,
            type: 'success'
          })
          this.sendOrder()
        } else {
          this.$notify({
            group: 'saved',
            title: `failed`,
            text: `edit profile failed`,
            type: 'warn'
          })
        }
      })();
    },
    duplicateOrder(orderId){
      (async () => {
        let response = await api.post(apiV2.orderDuplicate(orderId), {}, {needToken: true})
        if (response.status == 201) {
          this.toPayment(response.data.order.id)
        } else {
          let message
          if (response.status == 404) {
             message = response.data.detail
          } else if (response.status == 400) {
            message = response.data.message
          }
          this.$notify({
            group: 'saved',
            title: 'Fixing order failed.',
            text: message,
            type: 'warn'
          })
        }
      })();
    },
    toPayment(orderId){
      this.$router.push({name:'orderdetail', params: { id: orderId }})
      this.orderId = orderId
      this.orderExpired = false
      this.orderFixed = true
      this.getOrderDetail()
    },
  },
  watch: {
    campaigns(newValue, oldValue) {
      if (newValue.length > 0) {
        newValue.forEach(campaign => {
          this.totalOrder += campaign.net_price
        });
        this.subTotal = Math.round((100/110) * this.totalOrder)
        this.vat = this.totalOrder - this.subTotal
      }
    },
  },
  computed: {
    totalPrice() {
      return this.totalOrder
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.input input {
  height: 62px;
}

@include breakpoint (md) {
  .input{
    input {
      height: 46px;
      font-size: 12px;

      &:valid ~ label {
        font-size: 10px;
      }
    }
  }

  .textArea {
    textArea {
      font-size: 12px;

      &:valid ~ label {
        font-size: 10px;
      }
    }
  }

  .selectDropdown {
    .select {
      input {
        min-height: unset !important;
        height: 46px;
        font-size: 12px;

        &:valid ~ .select__title {
          font-size: 10px;
        }
      }
      // .select__icon {
      //   top: 15px;
      // }
    }
  }
}
</style>
